var React = require('react');

function GooglePlayInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"2","d":"M17.0671972 9.16079506L1.4513814.131287701C.806334197-.241735265 0 .224543443 0 .970488449L0 19.0295536C0 19.7754986.806334197 20.2416764 1.4513814 19.8687544L17.0671972 10.8391966C17.7122948 10.4662745 17.7122948 9.53376756 17.0671972 9.16079506zM.612 0L13.469 12.857M.612 20L13.469 7.143","transform":"translate(1 1)"}));
}

GooglePlayInline.defaultProps = {"width":"20","height":"22","viewBox":"0 0 20 22"};

module.exports = GooglePlayInline;

GooglePlayInline.default = GooglePlayInline;
